"use client";

import { Button } from "@heroui/react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="heroui flex items-center justify-center min-h-[60vh]">
      <div className="max-w-md px-6 text-center">
        <div className="mx-auto mb-5 size-12 rounded-full bg-danger-muted flex items-center justify-center">
          <span className="text-lg text-danger-text">!</span>
        </div>
        <h1 className="text-lg font-semibold text-text-primary mb-2">
          Something went wrong
        </h1>
        <p className="text-base text-text-tertiary mb-4 leading-relaxed">
          {error.message || "An unexpected error occurred."}
        </p>
        {error.digest && (
          <p className="text-3xs font-mono text-text-placeholder mb-5">
            Digest: {error.digest}
          </p>
        )}
        {process.env.NODE_ENV === "development" && error.stack && (
          <pre className="text-left text-3xs text-text-quaternary bg-surface-raised border border-border-tertiary rounded-lg p-4 overflow-auto max-h-50 mb-5 whitespace-pre-wrap wrap-break-word">
            {error.stack}
          </pre>
        )}
        <div className="flex gap-2 justify-center">
          <Button onPress={reset}>
            Try again
          </Button>
          <Button
            variant="ghost"
            onPress={() => (window.location.href = "/")}
          >
            Go home
          </Button>
        </div>
      </div>
    </div>
  );
}
